import React from "react";
import EngagementVideoPage from "../../ui/EngagementVideoPage";

const WheelchairCricket = () => (
  <EngagementVideoPage
    title="Wheelchair Cricket Tournament"
    videoUrl="https://www.youtube.com/embed/Su_LJwb7p3Q"
    videoTitle="Wheelchair Cricket Tournament"
  >
    <p>
      As part of World Kindness Week 2025, KU launched its &quot;Celebrating Abilities&quot; series by supporting the Wheelchair Cricket West Zone Championship at MIG Cricket Club, where students from St. Andrew&apos;s College and St. Francis Institute of Management & Research joined to cheer and honour the exceptional skill and resilience of the players. This collaboration with the Mumbai Wheelchair Cricket Team, led by Captain Rahul Ramugude, reinforced KU&apos;s commitment to inclusion and the celebration of human strength in all its forms.
    </p>
  </EngagementVideoPage>
);

export default WheelchairCricket;
